import React from "react";
import { customerNameById, shouldDisplayIdentificationAlert, insuranceTakerHasId, excludeGuardiansFromSigners } from "../../utils";
import DOMPurify from 'dompurify';
import PhotoIdModal from "../modals/photo-id-modal";
import { openModal } from "../../api/gui/actions";
import { fetchTilbod } from "../../api/offers/actions";
import { updateContractIdentification } from "../../api/id/actions";
import { setKey } from '../../api/insurance-takers/actions';

class IdSelection extends React.Component {
    constructor(props) {
        super(props)

        this.onClosePhotoIdModal = this.onClosePhotoIdModal.bind(this)
        this.bypassHandler = this.bypassHandler.bind(this)
    }

    signerHasExistingIdentification(id) {
        const { identification } = this.props
        if (identification && identification.customers[id] && !identification.customers[id].isFetching && identification.customers[id].done && identification.customers[id].Customer && identification.customers[id].Customer.Identification && identification.customers[id].Customer.Identification.IdentificationCard) {
            return true
        }
        return false
    }

    onClosePhotoIdModal() {
        if (this.props.newInsuranceTakers && this.props.newInsuranceTakers.insuranceTakers) {
            // Dispatch the fetchIdentification action for each signer
            const signers = this.props.signers
            signers.forEach(signer => {
                if (!this.props.newInsuranceTakers.insuranceTakers[signer].useExistingPhotoId) {
                    let input = {...this.props.newInsuranceTakers.insuranceTakers[signer]};
                    let newInfo = {
                        insuranceTakerId: signer,
                        validUntil: input.validUntil,
                        issueDate: input.issueDate,
                        issuer: input.issuer,
                        idNumber: input.idNumber,
                        idType: input.idType,
                        country: input.country,
                        images: input.images,
                        useExistingPhotoId: null,
                        submitIdLater: null,
                        useExistingPhotoId: false,
                    };

                    Promise.resolve(this.props.dispatch(updateContractIdentification(this.props.match.params.token, newInfo)))
                        .then(() => {
                            if (this.props.onSignerUpdate && signer === this.props.customerId) {
                                this.props.onSignerUpdate(signer)
                            }
                            this.props.dispatch(fetchTilbod(this.props.match.params.token, false))
                        })
                }
            });
        }
    }


    useExistingPhotoIdHandler(signer, value) {
        const {
            match,
            dispatch
        } = this.props

        dispatch(setKey({ key: 'useExistingPhotoId', value: value }, signer))
        dispatch(setKey({ key: 'submitIdLater', value: null }, signer))
        dispatch(setKey({ key: 'confirm', value: false }, signer))


        if (match.params.token) {
            Promise.resolve(
                dispatch(updateContractIdentification(match.params.token, { useExistingPhotoId: value, insuranceTakerId: signer }, signer))
            ).then(() => {
                dispatch(fetchTilbod(match.params.token, false))
            })
        }
    }

    bypassHandler(signer) {
        const {
            dispatch
        } = this.props
        dispatch(setKey({ key: 'confirm', value: true }, signer))
        dispatch(setKey({ key: 'useExistingPhotoId', value: null }, signer))
        dispatch(setKey({ key: 'submitIdLater', value: true }, signer))
    }


    render() {

        const {
            tilbod,
            identification,
            customerId,
            infoCollection,
            dispatch,
            offerQueryParameters,
            insuranceTakers,
            store,
            signers,
            peopleByKennitala,
            requirePhoto,
            formKey,
        } = this.props

        let key = customerId
        if (formKey) {
            key = formKey
        }
        return (
            <>
                {signers.map((insuranceTakerId) =>
                    <>
                        {insuranceTakerId === customerId && insuranceTakers.insuranceTakers[insuranceTakerId].modalPopulated && insuranceTakerHasId(insuranceTakers, insuranceTakerId) && !this.props.onSignerUpdate &&
                            <div className="alert alert-info mb-5">Skilríki hafa verið móttekin.</div>
                        }
                    </>
                )}

                {shouldDisplayIdentificationAlert(insuranceTakers, excludeGuardiansFromSigners(signers, infoCollection, offerQueryParameters), customerId) &&
                    <>
                        <div className="alert alert-warning mb-5">
                            <p>Ekki er hægt senda inn umsókn fyrr en búið er að skrá og hlaða upp mynd skilríkjum eða velja skilríki á skrá fyrir alla tryggingataka.</p>
                            {signers.map((insuranceTakerId) =>
                                <>

                                    {((tilbod && !insuranceTakerHasId(tilbod.jsondata.insuranceTakers, insuranceTakerId)) || !insuranceTakerHasId(insuranceTakers, insuranceTakerId)) && insuranceTakerId === customerId &&
                                        <>
                                            {!this.signerHasExistingIdentification(insuranceTakerId) ?
                                                <>
                                                    <a className="btn btn-outline-primary ml-5" data-toggle="modal" onClick={() => dispatch(openModal(`PhotoIdModal-${insuranceTakerId}`))}>Skrá skilríki - {customerNameById(insuranceTakerId, { peopleByKennitala })}</a>
                                                </>
                                                :
                                                <>
                                                    <div className="col-12 smoker">Tryggingataki: {customerNameById(insuranceTakerId, { peopleByKennitala })}</div>
                                                    <div className="col-12 smoker">
                                                        <input type="radio"
                                                            id={`useExistingPhotoId-true-${key}`}
                                                            onChange={() => this.useExistingPhotoIdHandler(insuranceTakerId, true)}
                                                            name={`useExistingPhotoId-true-${key}`}
                                                            checked={insuranceTakers.insuranceTakers[insuranceTakerId].useExistingPhotoId === true}
                                                            disabled={!this.signerHasExistingIdentification(insuranceTakerId)}
                                                        />
                                                        <label htmlFor={`useExistingPhotoId-true-${key}`} className="col-10 col-form-label">
                                                            Nota skilríki á skrá {this.signerHasExistingIdentification(insuranceTakerId) ? `(${identification.customers[customerId].Customer.Identification.LicenceTypeTxt} nr. ${identification.customers[customerId].Customer.Identification.IdentificationCard} gildir til ${identification.customers[customerId].Customer.Identification.LicenseEndDate})` : "(engin skilríki fundust)"}
                                                        </label>
                                                    </div>
                                                    <div className="col-12 smoker">
                                                        <input type="radio"
                                                            id={`useExistingPhotoId-false-${key}`}
                                                            onChange={() => this.useExistingPhotoIdHandler(insuranceTakerId, false)}
                                                            name={`useExistingPhotoId-false-${key}`}
                                                            checked={insuranceTakers.insuranceTakers[insuranceTakerId].useExistingPhotoId === false}
                                                        />
                                                        <label htmlFor={`useExistingPhotoId-false-${key}`} className="col-10 col-form-label">
                                                            Skrá ný skilríki og/eða hlaða upp mynd
                                                        </label>
                                                        {insuranceTakers.insuranceTakers[insuranceTakerId].useExistingPhotoId === false &&
                                                            <a className="btn btn-outline-primary ml-5" data-toggle="modal" onClick={() => dispatch(openModal(`PhotoIdModal-${insuranceTakerId}`))}>Skrá skilríki - {customerNameById(insuranceTakerId, { peopleByKennitala })}</a>
                                                        }

                                                    </div>
                                                    {(!this.props.requirePhoto || this.props.enableSubmitLater) &&
                                                        <div className="col-12 smoker">
                                                            <input type="radio"
                                                                id={`bypass-${key}`}
                                                                onChange={() => this.bypassHandler(insuranceTakerId)}
                                                                name="submitIdLater"
                                                                checked={insuranceTakers.insuranceTakers[insuranceTakerId].submitIdLater === true}
                                                            />
                                                            <label htmlFor={`bypass-${key}`} className="col-10 col-form-label">
                                                                Skila síðar
                                                            </label>
                                                        </div>
                                                    }
                                                </>
                                            }

                                        </>
                                    }
                                    {insuranceTakerId === customerId &&
                                        <PhotoIdModal requirePhoto={requirePhoto} tilbod={tilbod} customerId={insuranceTakerId} insuranceTaker={insuranceTakerId} id={`PhotoIdModal-${insuranceTakerId}`} store={store} infoCollection={infoCollection} callBack={this.onClosePhotoIdModal} />
                                    }
                                </>
                            )}
                        </div>
                    </>
                }


            </>
        )


    }
}

IdSelection.defaultProps = {
    requirePhoto: true,
    enableSubmitLater: false,
}

export default IdSelection



